/**
 * Translations for daily rituals + offline pet events (PR-3, v0.9.0).
 * Covers DailyRitualsPanel and OfflineEventModal.
 */
const rituals = {
  zh: {
    'rituals.title': '每日小仪式',
    'rituals.streak.card.title': '连续登录',
    'rituals.streak.days': '🔥 {n} 天',
    'rituals.streak.longest': '最长 {n} 天',
    'rituals.streak.total': '总共陪了 {n} 天啦',
    'rituals.streak.claim': '领 10 金币',
    'rituals.streak.claimed': '今日已领',

    'rituals.mystery.card.title': '神秘蛋',
    'rituals.mystery.cta': '👆 戳一下',
    'rituals.mystery.claimed': '今天已开过啦 ✨',
    'rituals.mystery.opening': '打开中…',

    'rituals.timeOfDay.card.title': '时段奖励',
    'rituals.timeOfDay.morning': '早安红包',
    'rituals.timeOfDay.night': '晚安红包',
    'rituals.timeOfDay.windowMorning': '07:00–09:00 可领',
    'rituals.timeOfDay.windowNight': '20:00–22:00 可领',
    'rituals.timeOfDay.notNow': '不在时段',
    'rituals.timeOfDay.claimed': '已领取',
    'rituals.timeOfDay.claim': '领取',

    'rituals.toast.coins': '+💰{amount}',
    'rituals.toast.checkin': '已记录第 {days} 天互动，+💰{amount}',
    'rituals.toast.food': '✨ 收到一份食物 +1',
    'rituals.toast.decor': '✨ 收到一件装饰 +1',
    'rituals.toast.alreadyClaimed': '今天已经领过啦～',
    'rituals.toast.notInWindow': '现在不是领取时段哦',
    'rituals.toast.error': '出了点小状况，等等再试',

    'rituals.event.modal.title': '它刚才在做什么？',
    'rituals.event.modal.ok': '好哒',
    'rituals.event.modal.subtitle': '{nickname} 想告诉你一件小事',
  },
  en: {
    'rituals.title': 'Daily rituals',
    'rituals.streak.card.title': 'Login streak',
    'rituals.streak.days': '🔥 {n} days',
    'rituals.streak.longest': 'Best {n} days',
    'rituals.streak.total': '{n} days together so far',
    'rituals.streak.claim': 'Claim 10 coins',
    'rituals.streak.claimed': 'Claimed today',

    'rituals.mystery.card.title': 'Mystery egg',
    'rituals.mystery.cta': '👆 Tap me',
    'rituals.mystery.claimed': 'Opened today ✨',
    'rituals.mystery.opening': 'Opening…',

    'rituals.timeOfDay.card.title': 'Time-of-day bonus',
    'rituals.timeOfDay.morning': 'Morning packet',
    'rituals.timeOfDay.night': 'Night packet',
    'rituals.timeOfDay.windowMorning': 'Open 07:00–09:00',
    'rituals.timeOfDay.windowNight': 'Open 20:00–22:00',
    'rituals.timeOfDay.notNow': 'Not the right time',
    'rituals.timeOfDay.claimed': 'Claimed',
    'rituals.timeOfDay.claim': 'Claim',

    'rituals.toast.coins': '+💰{amount}',
    'rituals.toast.checkin': 'Logged day {days} together, +💰{amount}',
    'rituals.toast.food': '✨ Got a food item +1',
    'rituals.toast.decor': '✨ Got a decor item +1',
    'rituals.toast.alreadyClaimed': "Already claimed today~",
    'rituals.toast.notInWindow': "It's not the right time of day",
    'rituals.toast.error': 'Something hiccuped, try again soon',

    'rituals.event.modal.title': 'What was your pet up to?',
    'rituals.event.modal.ok': 'Got it',
    'rituals.event.modal.subtitle': '{nickname} wants to tell you something',
  },
};

export default rituals;
